const CHILD_ID = 1
const ADOLESCENT_ID = 2
const ADULT_ID = 3
const ELDERLY_ID = 4

const TYPE_SENSITIVE = 1
const TYPE_PERSONAL = 2
const TYPE_FINANCIAL = 3
const TYPE_COMPORTAMENTAL = 4
const TYPE_ANOTHER_PERSONAL = 5
const TYPE_ANOTHER_FINANCIAL = 6
const TYPE_ANOTHER_COMPORTAMENTAL = 7

const SHARE_TYPE_INTERNAL_ID = 1
const SHARE_TYPE_EXTERNAL_ID = 2
const SHARE_TYPE_INTERNAL_AND_EXTERNAL_ID = 3

const DATA_PROTECTION_ELETRONIC_ID = 3
const DATA_PROTECTION_PHYSICAL_ID = 4
const DATA_PROTECTION_ELETRONIC_AND_PHYSICAL_ID = 5

const CHILD_LABEL = 'Criança (0 - 11 anos)'
const ADOLESCENT_LABEL = 'Adolescente (12 - 17)'
const ADULT_LABEL = 'Adulto (18 - 59)'
const ELDERLY_LABEL = 'Idoso (60+)'

const TYPE_SENSITIVE_LABEL = 'Sensível'
const TYPE_PERSONAL_LABEL = 'Pessoal'
const TYPE_FINANCIAL_LABEL = 'Financeiro'
const TYPE_COMPORTAMENTAL_LABEL = 'Comportamental'
const TYPE_ANOTHER_PERSONAL_LABEL = 'Outro Pessoal'
const TYPE_ANOTHER_FINANCIAL_LABEL = 'Outro Financeiro'
const TYPE_ANOTHER_COMPORTAMENTAL_LABEL = 'Outro Comportamental'

const SHARE_TYPE_IDS = [
  SHARE_TYPE_INTERNAL_ID,
  SHARE_TYPE_EXTERNAL_ID,
  SHARE_TYPE_INTERNAL_AND_EXTERNAL_ID,
]

const DATA_PROTECTION_IDS = [
  DATA_PROTECTION_ELETRONIC_ID,
  DATA_PROTECTION_PHYSICAL_ID,
  DATA_PROTECTION_ELETRONIC_AND_PHYSICAL_ID,
]

const OPTION_AGE_RANGE = [
  { id: CHILD_ID, name: CHILD_LABEL },
  { id: ADOLESCENT_ID, name: ADOLESCENT_LABEL },
  { id: ADULT_ID, name: ADULT_LABEL },
  { id: ELDERLY_ID, name: ELDERLY_LABEL },
]

const CONVERT_NAME = {
  1: CHILD_LABEL,
  2: ADOLESCENT_LABEL,
  3: ADULT_LABEL,
  4: ELDERLY_LABEL,
}

const DEFAULT_DATA_TYPE_LABELS = {
  [TYPE_SENSITIVE]: TYPE_SENSITIVE_LABEL,
  [TYPE_PERSONAL]: TYPE_PERSONAL_LABEL,
  [TYPE_FINANCIAL]: TYPE_FINANCIAL_LABEL,
  [TYPE_COMPORTAMENTAL]: TYPE_COMPORTAMENTAL_LABEL,
}

const DATA_TYPE_LABELS = {
  [TYPE_SENSITIVE]: TYPE_SENSITIVE_LABEL,
  [TYPE_PERSONAL]: TYPE_PERSONAL_LABEL,
  [TYPE_FINANCIAL]: TYPE_FINANCIAL_LABEL,
  [TYPE_COMPORTAMENTAL]: TYPE_COMPORTAMENTAL_LABEL,
  [TYPE_ANOTHER_PERSONAL]: TYPE_ANOTHER_PERSONAL_LABEL,
  [TYPE_ANOTHER_FINANCIAL]: TYPE_ANOTHER_FINANCIAL_LABEL,
  [TYPE_ANOTHER_COMPORTAMENTAL]: TYPE_ANOTHER_COMPORTAMENTAL_LABEL,
}

export default {
  ADOLESCENT_ID,
  ADULT_ID,
  CHILD_ID,
  CONVERT_NAME,
  DATA_PROTECTION_IDS,
  DATA_TYPE_LABELS,
  DEFAULT_DATA_TYPE_LABELS,
  ELDERLY_ID,
  OPTION_AGE_RANGE,
  SHARE_TYPE_IDS,
}
